module.exports = __webpack_public_path__ + "img/4.015904d2.png";